import { useMemo } from 'react';
import { AssetStatus, AssetStatusLabels } from '../enum';
import { SelectInputOption } from '@/components/inputs/SelectInput';
import { AssetApi } from '../models';

const useAssetOptions = (assets?: AssetApi[]) => {
  const assetStatus = useMemo(
    () =>
      Object.entries(AssetStatus).map(([statusKey, statusValue]) => ({
        label: AssetStatusLabels[statusValue as AssetStatus],
        value: statusKey,
      })),
    []
  );

  const assetOptions = useMemo<SelectInputOption[]>(
    () =>
      (assets ?? []).map((asset: AssetApi) => ({
        value: asset.id.toString(),
        label: asset.serialNumber,
      })),
    [assets]
  );

  return { assetStatus, assetOptions };
};

export default useAssetOptions;
